import { render, staticRenderFns } from "./PetugasBankSoalTidakAktif.vue?vue&type=template&id=c5ebb368&"
import script from "./PetugasBankSoalTidakAktif.vue?vue&type=script&lang=js&"
export * from "./PetugasBankSoalTidakAktif.vue?vue&type=script&lang=js&"
import style0 from "./PetugasBankSoalTidakAktif.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports